//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { BytesLike, ZeroAddress, ZeroHash } from 'ethers'
import * as yup from 'yup'
import { EthAddr, TxHash } from './SchemaTypes'
import { APR, ERC20Wei, ERC20WeiSigned, getRequiredAddress } from './conversions'
import { ChainConfigName } from './DeploymentConfigs'

export const MESSAGE_TO_SIGN = 'Open Trade Account Verification'

export const DEV_HH_URL = 'http://34.237.243.248:8549'
export const DEMO_HH_URL = 'http://3.86.245.235:8549'
export const QA_HH_URL = 'http://52.87.249.82:8549'

//const AUTO_HH_URL = 'http://54.83.100.33:8545'

export const DEV_SEPOLIA_FOR_JEST_SERVICE_CONFIGURATION_ADDR = '0x549C830B222Ac346ec27c603a5Da46d345989816'
export const AVALANCHE_SERVICE_CONFIGURATION_ADDR = '0xa3bE07c2734ed1CE269Cf026Cbe8D09d146014e1'
export const LOCALHOST_UPGRADE_SERVICE_CONFIGURATION_ADDR = '0xDDb38137De84439b0045e19CCA8fB1880002474b'
export const LOCALHOST_SERVICE_CONFIGURATION_ADDR = '0x549C830B222Ac346ec27c603a5Da46d345989816' // '0x29AD3b3231a7a1a2f5Bc44f2C3dA27F50Cb1cB97'
export const MAINNET_SERVICE_CONFIGURATION_ADDR = '0xec4F65e0A0268ff38ECEc711AD5159b96dAbaB98'
export const QA2_SERVICE_CONFIGURATION_ADDR = '0x9e653B96b90eE3F60db0084271693f35cf572BAD' // '0x29AD3b3231a7a1a2f5Bc44f2C3dA27F50Cb1cB97'
export const QASEP_SERVICE_CONFIGURATION_ADDR = '0xC14b54FA8417D2a1D6Ecc31563e0a5e9E090C449' // '0xbedd20F7613b4cCEbdDf7C7296460319B8e1934E' // '0xfF8C215A77847cd152AD095d0bEDFa2f70617c74' // '0x4B9AD4442F220199FE4a61093126A1E95Ce29D61' // '0x9455e81215d0176347632C93C78bA060B2FF03FB' //'0x1D6e4758EE51Ed1976700fc1efd594cCff9436F9' // '0x3d5bfB2D620F8eF3077f2df5033FdbDB8872969F'
export const TOM_SERVICE_CONFIGURATION_ADDR = '0x62aF6aa1511FE897ffB6950268004538aa9A1494' //'0x3d5bfB2D620F8eF3077f2df5033FdbDB8872969F' // '0xC022987cb57110A4110519a749416af39ffF170E'
export const DEV_SEPOLIA_SERVICE_CONFIGURATION_ADDR = '0x2D2a27C3a778414DaD4Db79589e83725184aC64B' // '0x8EF4F274B38D1e2Bb5edAD1Fab46D0Fb596967B4' // '0x5737804c6F0681E64f3CAFbE645ee00353b82B83'
export const WILLIAM_SERVICE_CONFIGURATION_ADDR = ''
export const SANDBOX_SERVICE_CONFIGURATION_ADDR = '0xf08676003E05175cdD48fbD90b2AC3de230b4CDB' // '0x526eCD1166cD535316627e73BBf092a959a2156F'
export const QA_FUJI_SERVICE_CONFIGURATION_ADDR = '0x7660F78F8dD9Be7Dc6F1B14c5E79Ed4833a88939' // '0x7760Ac87014De4014512Cc1af35e614eF6a46117' // '0x755449CBAa22E162B9Be9048085E1Ec3702B2Da8'
export const DEV_FUJI_SERVICE_CONFIGURATION_ADDR = '0xbEe469ECA2aC896154A224826521aE74b24D370B' // '0x106D52b73046373b3019b90842750Fc63B2758a8' // '0x755449CBAa22E162B9Be9048085E1Ec3702B2Da8'
export const SANDBOX_FUJI_SERVICE_CONFIGURATION_ADDR = '0xF061a3e9fAf00eA3FB8b3316AdDd3eB9792FE13b'
export const ETHERSCAN_FUJI = 'https://testnet.snowtrace.io/tx'
export const ETHERSCAN_MAINNET = 'https://etherscan.io/tx'
export const ETHERSCAN_GOERLI = 'https://goerli.etherscan.io/tx'
export const ETHERSCAN_SEPOLIA = 'https://sepolia.etherscan.io/tx'
export const ETHERSCAN_AVALANCHE = 'https://snowtrace.io/tx'
export const WALLET_CONNECT_PROJECT_ID = '95a7421b836a16c2c5b981ab3393a4ca'
export const WALLET_CONNECT_DEV_PROJECT_ID = '9c66a40540005698d2ccabbb3a734523'

const _DEV_SEP_JEST_REST_APIKEY = 'dpayAo71PyaGW6Q286MQ33xFr8Oh3Y4u9dkZiMB9'
const _DEV_SEP_REST_APIKEY = 'alwqtegH5Q1BEZb6oluu78H2SRCsS8pvacwgm1cx'
const _DEV_FUJI__REST_APIKEY = 'Rb7rptSn661tkArIUojam826ain0nYv21QOcqYrO'
const _QA_SEP_REST_APIKEY = 'ZM4MFWxWiE7hRS4IE431s9uoggJag0Q4ToN4LcWf'
const _QA_FUJI_REST_APIKEY = 'ie9C2w3i8UtzOcSE6bIBrr9ZRWykUXa6L16Lmt10'
const _SANDBOX_SEPOLIA_REST_APIKEY = 'XcYKNc0F9D8eVM37g9f8D10oyqHQJYC87Q40Qron'
const _SANDBOX_FUJI_REST_APIKEY = 'KN1JOn8pBF3KYH2z8cCov3AOYcjK0yEA5AdaoMXL'
const _MAINNET_REST_APIKEY = '3aPotjl5WK86QwxwQFLie1ISs5j2mAER7hEcugNU'
const _AVALANCHE_REST_APIKEY = 'Lpn7FNkZ7wd51e7nJ2dI9mT7qYdjIie5VdECRRTb'

export const LOCAL_HOST = process.env.GITHUB_RUN_NUMBER ? 'localdev' : 'localdev'

export const IGNORED_POOLS: EthAddr[] = ['0x3b532b1eA13F6d0D2dFB837c22b72eAdF1294538'] // Flex Pool avalanche

export const DUMMY_TEST_ADDRESSES: EthAddr[] = [
  '0xF1B410234911C781551B828C82F745Be81207787',
  '0xCA0227A861B82a2d229B8aAD95eb3f89EA2Af219',
  '0x1ff85CBD8C7E6555323D11f1b79828268Eac1915',
  '0x6bDCF3df5073715f8FDDe4E8Bb939f3Bd59d1f41',
]
export type StageName =
  | 'local'
  | 'dev'
  | 'qa'
  | 'sandbox'
  | 'sandboxcanary'
  | 'prod'
  | 'prodcanary'
  | 'devotto'
  | 'devtom'

export const accountIdForStage: Record<StageName, number> = {
  local: 929184677539,
  devotto: 850995562482,
  devtom: 850995562482,
  dev: 850995562482,
  qa: 954976295415,
  sandbox: 593793051323,
  sandboxcanary: 593793051323,
  prod: 929184677539,
  prodcanary: 724772076161,
}

export enum RoleEnum {
  OPERATOR = 'OPERATOR',
  POOL_ADMIN = 'POOL_ADMIN',
  LENDER = 'LENDER',
  BORROWER = 'BORROWER',
  BORROWER_WALLET = 'BORROWER_WALLET',
  TO_BE_DETERMINED = 'TO_BE_DETERMINED',
  NONE = 'NONE',
}
export enum WalletEnum {
  METAMASK = 'METAMASK',
  COINBASE = 'COINBASE',
  WALLET_CONNECT = 'WALLET_CONNECT',
  JEST = 'JEST',
  PRIVATE_KEY_STRING = 'PRIVATE_KEY_STRING',
  APP_KIT = 'APP_KIT',
  UNCONNECTED = 'UNCONNECTED',
}

export enum SlsStartConfigurationEnum {
  Pools = 'Pools',
  NoPools = 'NoPools',
  MainnetFork = 'MainnetFork',

  LocalRebuild = 'LocalRebuild',
  LocalRestore = 'LocalRestore',
}

export interface ProtocolVersions {
  ServiceConfiguration: string
  PoolRegistry: string
  QueryLib: string
  PoolLib: string
  LoanLib: string
  ToSAcceptanceRegistry: string
  WithdrawControllerFactory: string
  WithdrawDepositControllerFactoryFlex: string
  PoolControllerFactory: string
  PoolControllerFactoryFlex: string
  PoolFactory: string
  PoolFactoryFlex: string
  PoolAccessControlFactory: string
  PoolLibFlex: string
  VaultFactory: string

  Pool: string
  PoolAccessControl: string
  PoolController: string
  WithdrawController: string
  Loan: string
  PoolFlex: string
  PoolControllerFlex: string
  WithdrawDepostControllerFlex: string
}

export const chainIdToNetwork = (chainId: number): string => {
  if (chainId == ChainId.HARDHAT) {
    return 'hardhat'
  }
  if (chainId == ChainId.GOERLI) {
    return 'goerli'
  }
  if (chainId == ChainId.SEPOLIA) {
    return 'sepolia'
  }
  if (chainId == ChainId.MAINNET) {
    return 'mainnet'
  }
  if (chainId == ChainId.FUJI) {
    return 'fuji'
  }
  if (chainId == ChainId.AVALANCHE) {
    return 'avalanche'
  }
  throw new Error(`Unknown chainId ${chainId}`)
}

export const networkToChainId = (network: string): number => {
  if (network === 'localhost' || network === 'hardhat') {
    return ChainId.HARDHAT
  }

  if (network === 'sandbox') {
    return ChainId.GOERLI
  }
  if (network === 'goerli') {
    return ChainId.GOERLI
  }
  if (network === 'woo') {
    return ChainId.GOERLI
  }
  if (network === 'sepolia') {
    return ChainId.SEPOLIA
  }
  throw new Error(`Unknown network ${network}`)
}

// Define valid ChainConfigName values for validation
const VALID_CHAIN_CONFIG_NAMES: ChainConfigName[] = [
  'Hardhat',
  'DevFuji',
  'DevSepolia',
  'QaFuji',
  'QaSepolia',
  'SandboxFuji',
  'SandboxSepolia',
  'Ethereum',
  'Avalanche',
  'DevPlume',
  'QaPlume',
  'SandboxPlume',
  'Plume',
]

// Create a yup validator for ChainConfigName
export const yupChainConfigNameOptional = yup
  .string()
  .optional()
  .test('is-valid-chain-config-name', 'Invalid chain configuration name', (value: string | undefined) => {
    if (value === undefined || value === '') {
      return true // Allow undefined/empty for optional
    }
    return VALID_CHAIN_CONFIG_NAMES.includes(value as ChainConfigName)
  })

export const yupEthAddrOptional = yup
  .string()
  .optional()
  .length(42)
  .matches(/^0x[a-fA-F0-9]{40}$/)

export const yupNumberStringOptional = yup
  .string()
  .optional()
  .matches(/^[0-9]*$/)
export const yupEthAddrRequired = yup
  .string<EthAddr>()
  .length(42)
  .required()
  .matches(/^0x[a-fA-F0-9]{40}$/)
  .default(ZeroAddress)
  .transform((value: string) => getRequiredAddress(value))
export const yupTxHashRequired = yup
  .string<TxHash>()
  .length(66)
  .matches(/^0x[a-fA-F0-9]{64}$/)
  .default(ZeroHash as TxHash)
export const yupTxHashOptional = yup
  .string<TxHash>()
  .length(66)
  .matches(/^0x[a-fA-F0-9]{64}$/)

export const yupErc20WeiRequired = yup
  .string<ERC20Wei>()
  .required()
  .matches(/^[0-9]*$/)
  .default('0')
export const yupErc20WeiOptional = yup
  .string<ERC20Wei>()
  .matches(/^[0-9]*$/)
  .optional()

export const yupErc20WeiSigned = yup
  .string<ERC20WeiSigned>()
  .matches(/^[-]?[0-9]*$/)
  .default('0')
export const yupApr = yup
  .string<APR>()
  .required()
  .matches(/^[0-9]*$/)
  .default('0')
export const yupQueryObjectOptional = yup.object({}).optional()
export const yupQueryStringRequired = yup.string().required()
export const yupQueryBooleanOptional = yup.boolean().optional()
export const yupQueryDateStringOptional = yup
  .string()
  .optional()
  .test('is-DayParam', '${path} is not in YYYY-MM-DD format', (value: string | undefined) => {
    try {
      if (value === '' || value === undefined) {
        return true
      }
      const startDateLocal = new Date(value + 'T00:00:00Z')
      if (isNaN(startDateLocal.getTime())) {
        return false
      }
    } catch (_error) {
      return false
    }

    return true
  })

export enum TIME_OF_DAY {
  BEFORE_CLOSE_OF_BUSINESS = 0,
  AFTER_CLOSE_OF_BUSINESS = 1,
}
export interface ChainError extends Error {
  info: any
  error?: ChainError
  reason?: string
  originalError?: ChainError
  providerWritable: string
  data: {
    originalError: ChainError
    data: BytesLike
  }
}

export const ONE_DAY = 3600 * 24

export enum DynamicDepositStatusEnum {
  UNKNOWN = 'Unknown',
  CONTRACT = 'Contract',
  TRANSFER_PENDING = 'Transfer Pending',
  TRANSFER_ACCEPTED = 'Transfer Accepted',
  OFFCHAIN = 'Offchain',
  ACCOUNT_CREDIT = 'Account Credit',
}

export enum PoolLifeCycleState {
  Initialized = 0,
  Active = 1,
  Closed = 2,
  DisruptionOrDefault = 3,
}

export const DepositTypeToString = {
  0: 'UndefinedDeposit',
  1: 'ContractDeposit',
  2: 'OffChainDeposit',
  3: 'CrossChainDeposit',
  4: 'TransferDeposit',
}

export const PoolStateToString = {
  0: 'Initialized',
  1: 'Active',
  2: 'Closed',
  3: 'DisruptionOrDefault',
}
export enum PoolRolloverState {
  EarlyRolloverInitiate = 0, // 0 accept Deposits and WithdrawRequests, no early withdraws) transitionTiming = time to expected rollover */
  RolloverInitiate, // 1 no deposits or withdrawRequests)  transitionTiming = time left of  expected rollover */
  LateRolloverInitiate, // 2  transitionTiming = time expected rollover pastDue */
  EarlyRolloverFinalize, // 3 Requested
  RolloverFinalize, // 4 Requested
  LateRolloverFinalize, // 5 Requested
  EarlyRepayWithdrawsAndFees, // 6 Matured loan
  RepayWithdrawsAndFees, // 7 Matured loan
  LateRepayWithdrawsAndFees, // 8 Matured loan
  EarlyReleaseRedemptions, // 9 Matured loan
  ReleaseRedemptions, // 10 Matured loan
  LateReleaseRedemptions, // 11 Matured loan
  CreateNextLoan, // 12
  ApproveNextLoan, // 13
  LateApproveNextLoan, // 14
  LoanNeedsRescheduling, // 15
  NotRollingOver, // 16
  InvalidState, // 17
}
export const PoolRolloverStateToString: Record<number, string> = {
  0: 'EarlyRolloverInitiate', // 0 accept Deposits and WithdrawRequests, no early withdraws) transitionTiming = time to expected rollover */
  1: 'RolloverInitiate', // 1 no deposits or withdrawRequests)  transitionTiming = time left of  expected rollover */
  2: 'LateRolloverInitiate', // 2  transitionTiming = time expected rollover pastDue */
  3: 'EarlyRolloverFinalize', // 3 Requested
  4: 'RolloverFinalize', // 4 Requested
  5: 'LateRolloverFinalize', // 5 Requested
  6: 'EarlyRepayWithdrawsAndFees', // 6 Matured loan
  7: 'RepayWithdrawsAndFees', // 7 Matured loan
  8: 'LateRepayWithdrawsAndFees', // 8 Matured loan
  9: 'EarlyReleaseRedemptions', // 9 Matured loan
  10: 'ReleaseRedemptions', // 10 Matured loan
  11: 'LateReleaseRedemptions', // 11 Matured loan
  12: 'CreateNextLoan', // 12
  13: 'ApproveNextLoan', // 13
  14: 'LateApproveNextLoan', // 14
  15: 'LoanNeedsRescheduling', // 15
  16: 'NotRollingOver', // 16
  17: 'InvalidState', // 17
}
export const EXCHANGE_RATE_ONE = 1000000_000000_000000n
export enum PoolTypeEnum {
  Term = 0,
  FlexibleRate = 1,
  Dynamic = 2,
  NotPool = 10,
}
export const PoolTypeToString: Record<number, string> = {
  0: 'Term Pool',
  1: 'Flexible Rate Pool',
  2: 'Dynamic Pool',
}

export enum ExchangeRateTypeEnum {
  Unset = 0,
  Dynamic = 1,
  Linear = 2,
  Compounding = 3,
  Term = 4,
}
export const ExchangeRateTypeToString: Record<number, string> = {
  0: 'Unset',
  1: 'Dynamic',
  2: 'Linear',
  3: 'Compounding',
  4: 'Term',
}

export enum RolloverTypeEnum {
  NeedsFullRepayment = 0,
  NeedsPartialRepayment = 1,
  NetAdditionalDeposits = 2,
}

export const RolloverTypeToString: Record<number, string> = {
  0: 'Needs Full Repayment',
  1: 'Needs Partial Repayment',
  2: 'Net Additional Deposits',
}
export enum PoolRolloverActor {
  PoolAdmin,
  BorrowerManager, // 1
  BorrowerWallet, // 2
  Investor, // 3
}
export const PoolRolloverActorToString: Record<number, string> = {
  0: 'PoolAdmin', // 0
  1: 'BorrowerManager', // 1
  2: 'BorrowerWallet', // 2
  3: 'Investor', // 3
}

export enum LoanLifeCycleState {
  Requested = 0,
  Canceled = 1,
  Funded = 2,
  Matured = 3,
  Active = 4,
  Settled = 5,
}
export const LoanStateToString: Record<number, string> = {
  0: 'Requested',
  1: 'Canceled',
  2: 'Funded',
  3: 'Matured',
  4: 'Funded',
  5: 'Active',
  6: 'Settled',
}
export enum LoanTransitionState {
  Requested = 0,
  ApprovedForDeposits = 1,
  TransitioningFundsIn = 2,
  AccruingInterest = 3,
  RedemptionsClosed = 4,
  TransitioningFundsOut = 5,
  RedemptionsReleased = 6,
}
export const LoanTransitionStateToString: Record<number, string> = {
  0: 'Requested',
  1: 'ApprovedForDeposits',
  2: 'TransitioningFundsIn',
  3: 'AccruingInterest',
  4: 'RedemptionsClosed',
  5: 'TransitioningFundsOut',
  6: 'RedemptionsReleased',
}
export enum LiquidityPoolLifeCycleEnum {
  Initialized = 'Initialized',
  Active = 'Active',
  Closed = 'Closed',
  DisruptionOrDefault = 'DisruptionOrDefault',
}

export enum InvestmentLifeCycleEnum {
  FORMATION = 'FORMATION',
  PUBLISHED = 'PUBLISHED',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED',
}

export enum WireStatusEnum {
  pending = 'pending',
  complete = 'complete',
  failed = 'failed',
}

/* eslint-disable  @typescript-eslint/no-duplicate-enum-values */
export enum WireErrorCodeEnum {
  insufficient_funds = 'insufficient_funds',
  transaction_denied = 'transaction_denied',
  transaction_failed = 'transaction_failed',
  transaction_returned = 'transaction_returned',
  bank_transaction_error = 'bank_transaction_error',
  fiat_account_limit_exceeded = 'bank_transaction_error',
  invalid_bank_account_number = 'invalid_bank_account_number',
  invalid_ach_rtn = 'invalid_ach_rtn',
  invalid_wire_rtn = 'invalid_wire_rtn',
  vendor_inactive = 'vendor_inactive',
  none = '',
}

export const roleToRoleEnum = (role: string): RoleEnum => {
  if (role.toLowerCase() === 'admin') {
    return RoleEnum.POOL_ADMIN
  }
  if (role.toLowerCase() === 'borrower') {
    return RoleEnum.BORROWER
  }
  if (role.toLowerCase() === 'lender') {
    return RoleEnum.LENDER
  }
  if (role.toLowerCase() === 'investor') {
    return RoleEnum.LENDER
  }
  return RoleEnum.TO_BE_DETERMINED
}

export enum PayoutTypeEnum {
  wire = 'wire',
  ach = 'ach',
  sepa = 'sepa',
  signet = 'signet',
}

export enum ObjectTypeEnum {
  POOL = 'POOL',
  LOAN = 'LOAN',
  WITHDRAWAL = 'WITHDRAWAL',
  WALLET = 'WALLET',
}

export enum ActivityEnum {
  POOL_REFRESH = 'POOL_REFRESH',
  POOL_CREATE = 'POOL_CREATE',
  POOL_ACTIVATE = 'POOL_ACTIVATE',
  POOL_FIRST_LOSS_NOT_FUNDED = 'POOL_FIRST_LOSS_NOT_FUNDED',
  POOL_NO_LOANS = 'POOL_NO_LOANS',
  POOL_LENDER_FUNDS_DUE = 'POOL_LENDER_FUNDS_DUE',
  POOL_DTO = 'POOL_DTO',
  POOL_CTO = 'POOL_CTO',
  POOL_DEPOSIT = 'POOL_DEPOSIT',
  POOL_DEPOSIT_APPROVE = 'POOL_DEPOSIT_APPROVE',
  WITHDRAW = 'WITHDRAW',
  WITHDRAW_FEES = 'WITHDRAW_FEES',
  WITHDRAW_REQUEST_DUE = 'WITHDRAW_REQUEST_DUE',
  WITHDRAW_REQUEST = 'WITHDRAW_REQUEST',
  WITHDRAW_AVAILABLE = 'WITHDRAW_AVAILABLE',
  WITHDRAW_REQUEST_CANCEL = 'WITHDRAW_REQUEST_CANCEL',
  EARLY_WITHDRAW_REQUEST = 'EARLY_WITHDRAW_REQUEST',
  LOAN_FUND = 'LOAN_FUND',
  LOAN_CTO = 'LOAN_CTO',
  LOAN_NEEDS_FUNDING = 'LOAN_NEEDS_FUNDING',
  LOAN_DRAW_DOWN = 'LOAN_DRAW_DOWN',
  LOAN_REPAY = 'LOAN_REPAY',
  LOAN_CREATE = 'LOAN_CREATE',
  LOAN_APPROVE = 'LOAN_APPROVE',
  WALLET_CONFIGURATION = 'WALLET_CONFIGURATION',
  TOS_ERROR = 'TOS_ERROR',
  TOS = 'TOS',
  POOL_LENDER_BALANCES = 'POOL_LENDER_BALANCES',
  POOL_BALANCES = 'POOL_BALANCES',
  ChainTransfer = 'Chain Transfer',
  DEPLOYMENT_CONFIGURATION = 'DEPLOYMENT_CONFIGURATION',
  DAILY_ACCRUAL_FLEX = 'DAILY_ACCRUAL_FLEX',
  ROLLOVER_INITIATE = 'ROLLOVER_INITIATE',
  POOL_RELEASE_FLEX_WITHDRAWAL = 'POOL_RELEASE_FLEX_WITHDRAWAL',
  POOL_ROLLOVER_FINALIZE = 'POOL_ROLLOVER_FINALIZE',
  POOL_SET_FLEX_INTEREST_RATE = 'POOL_SET_FLEX_INTEREST_RATE',
  COMPLETE_ROLLOVER_NET_PAYMENT = 'COMPLETE_ROLLOVER_NET_PAYMENT',
  BOPRRWER_TRANSFER_REPAY_FLEX_WITHDRAWAL = 'BOPRRWER_TRANSFER_REPAY_FLEX_WITHDRAWAL',
  FECTH_CHAIN_TIMESTAMP_DELTA = 'FECTH_CHAIN_TIMESTAMP_DELTA',
  POOL_ALLOW_PARTICIPATION = 'POOL_ALLOW_PARTICIPATION',
  LOGIN = 'LOGIN',
  CLOCK_REFRESH = 'CLOCK_REFRESH',
  POOL_DEBIT_CREDIT = 'POOL_DEBIT_CREDIT',
  DAILY_ACCRUAL_DYNAMIC = 'DAILY_ACCRUAL_DYNAMIC',
}

export enum AlertLevelEnum {
  REQUIRED = 'REQUIRED',
  INFORMATION = 'INFORMATION',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export enum PoolTabEnum {
  OVERVIEW = 'OVERVIEW',
  HOLDINGS = 'HOLDINGS',
  ACCESS_LIST = 'ACCESS_LIST',
  DEPOSITS = 'DEPOSITS',
  WITHDRAWS = 'WITHDRAWS',
  LENDER_VIEW = 'LENDER_VIEW',
  SCHEDULE = 'SCHEDULE',
  LEGAL = 'LEGAL',
  ASSETS = 'ASSETS',
  LOANS = 'LOANS',
  WITHDRAW_EVENTS = 'WITHDRAW_EVENTS',
  CONTRACT_ADDRESSES = 'CONTRACT_ADDRESSES',
  FLEX_CALENDAR = 'FLEX_CALENDAR',
  OFFCHAIN_DATA = 'OFFCHAIN_DATA',
  REPORTS = 'REPORTS',
}

export enum TraceEventEnum {
  TRANSFER = 'TRANSFER',
  DEPOSIT = 'DEPOSIT',
  LOAN_CREATED = 'LOAN_CREATED',
  LOAN_DRAWDOWN = 'LOAN_DRAWDOWN',
  LOAN_REPAY = 'LOAN_REPAY',
  LOAN_MATURED = 'LOAN_MATURED',
  INVEST = 'INVEST',
  LOAN_FUNDED = 'LOAN_FUNDED',
  WITHDRAW_REQUESTED = 'WITHDRAW_REQUESTED',
  WITHDRAW = 'WITHDRAW',
  POOL_CRANKED = 'POOL_CRANKED',
  WITHDRAW_REQUEST_CANCELLED = 'WITHDRAW_REQUEST_CANCELLED',
  POOL_CREATED = 'POOL_CREATED',
  POOL_WITHDRAW = 'POOL_WITHDRAW',
  FUND_FIRST_LOSS = 'FUND_FIRST_LOSS',
  COLLECT_FEES = 'COLLECT_FEES',
  REINVEST = 'REINVEST',
}

export enum IconEnum {
  DowLeftArrowIcon = 'DowLeftArrowIcon',
}

export enum PerfTabEnum {
  OVERVIEW = 'OVERVIEW',
  DEPOSITS = 'DEPOSITS',
  WITHDRAWALS = 'WITHDRAWALS',
}
export enum DynamicExchangeRateTypeEnum {
  Undefined,
  Dynamic,
  Linear,
  Compounding,
  Term,
}

export enum DynamicExchangeRateTypeStringEnum {
  Undefined = 'Undefined',
  Dynamic = 'Dynamic',
  Linear = 'Linear',
  Compounding = 'Compounding',
  Term = 'Term',
}

export enum ReportDataShape {
  UNKNOWN = 'UNKNOWN',
  POOL_EVENTS = 'POOL_EVENTS',
  POOL_EVENTS_LENDER = 'POOL_EVENTS_LENDER',
  LENDER_TIME_PERIOD_TERM = 'LENDER_TIME_PERIOD_TERM',
  LENDER_TIME_PERIOD_FLEX = 'LENDER_TIME_PERIOD_FLEX',
  LENDER_TIME_PERIOD_DYNAMIC = 'LENDER_TIME_PERIOD_DYNAMIC',
  LENDER_TIME_PERIOD_TERM_LENDER = 'LENDER_TIME_PERIOD_TERM_LENDER',
  LENDER_TIME_PERIOD_FLEX_LENDER = 'LENDER_TIME_PERIOD_FLEX_LENDER',
  LENDER_TIME_PERIOD_DYNAMIC_LENDER = 'LENDER_TIME_PERIOD_DYNAMIC_LENDER',
  POOL_OVERVIEW_FLEX = 'POOL_OVERVIEW_FLEX',
  POOL_OVERVIEW_TERM = 'POOL_OVERVIEW_TERM',
  POOL_OVERVIEW_DYNAMIC = 'POOL_OVERVIEW_DYNAMIC',
  PERFORMANCE = 'PERFORMANCE',
}

export enum ChainId {
  HARDHAT = 31337,
  GOERLI = 5,
  SEPOLIA = 11155111,
  MAINNET = 1,
  FUJI = 43113,
  AVALANCHE = 43114,
  PLUME_TESTNET = 98867,
  PLUME_MAINNET = 98866,
}
